import { Colors } from '@/config';
import { Badge, Tag } from '@arco-design/web-react';
import React from 'react';

// 1 和  2 两个值， 对应两个显示。
export function DisplayOppositeOption({
  value = 1,
  display = ['是', '否'],
  type = 'badge',
}: {
  value: 1 | 2;
  display?: [string, string];
  type?: 'badge' | 'tag';
}) {
  const colors = [Colors.GREEN, Colors.RED];
  if (type === 'tag') {
    return <Tag color={colors[value - 1]}>{display[value - 1]}</Tag>;
  }
  return <Badge color={colors[value - 1]} text={display[value - 1]} />;
}
